import React from 'react';
import {
  Container, Typography, Box, Grid,
} from '@mui/material';
import StyledBox from 'views/rebranded-module/HomeViewV2/components/UI/CardsLayoutSection/CardsLayoutSection.styles';
import { Typography700, ImgBox } from 'views/common/components';
import { useSelector } from 'react-redux';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import PATHS from 'lib/navigation/paths';
import NavigatorLink from 'views/rebranded-module/common/components/Logical/NavigatorLink';
import { useContent } from 'views/rebranded-module/common/context/useContent';

const CardsLayoutSection = () => {
  const content = useContent('HomePage');
  const { showMembership } = useSelector((state) => state.globalData);

  const mainCards = [
    {
      id: 1,
      title: content.rentalsCardTitle,
      desc: content.rentalsCardDesc,
      linkText: content.rentalsCardLinkText,
      linkPath: PATHS.motorcycleRental(),
      imgSrc: content.rentalsCardImageLarge?.url,
      SMImgSrc: content.rentalsCardImageSmall.url,
    },
    {
      id: 2,
      title: content.offroadCardTitle,
      desc: content.offroadCardDesc,
      linkText: content.offroadCardLinkText,
      linkPath: PATHS.guidedOffroadTour.index(),
      imgSrc: content.offroadCardImageSmall?.url,
      SMImgSrc: content.offroadCardImageLarge?.url,
    },
  ];

  const cards = [
    ...mainCards,
    showMembership
      ? {
        id: 3,
        title: content.clubCardTitle,
        desc: content.clubCardDesc,
        linkText: content.clubCardLinkText,
        linkPath: PATHS.motorcycleClub.index(),
        imgSrc: content.clubCardImageLarge?.url,
        SMImgSrc: content.clubCardImageSmall?.url,
      }
      : {
        id: 4,
        title: content.toursCardTitle,
        desc: content.toursCardDesc,
        linkText: content.toursCardLinkText,
        linkPath: PATHS.motorcycleTours.index(),
        imgSrc: content.toursCardImageLarge?.url,
        SMImgSrc: content.toursCardImageSmall?.url,
      },
  ];
  return (
    <StyledBox>
      <Container maxWidth="xl">
        <Grid
          container
          columnSpacing={{ xl: 6, lg: 4 }}
          rowSpacing={{ md: 3.75, sm: 3.5 }}>
          {cards.map((card) => (
            <Grid item lg={4} md={12} sm={12} key={card.id}>
              <Box className="CLSCard">
                <Box className="CLSCardContent">
                  <Box className="CLSTextcontent">
                    <Typography700 variant="h3" className="CLSCardTitle">
                      {card.title}
                    </Typography700>
                    <Typography
                      compoeent="p"
                      variant="body2"
                      className="CLSCardDesc">
                      {card.desc}
                    </Typography>
                    <NavigatorLink
                      className="CLSCardBtn"
                      href={card.linkPath}
                      target="_blank">
                      <Typography className="CLSCardBtnText" variant="span">
                        {card.linkText}
                      </Typography>
                      <KeyboardArrowRightIcon className="CLSCardBtnIcon" />
                    </NavigatorLink>
                  </Box>
                </Box>
                <Box className="ISOverlyer" />
                <Box className="CLSImg showDESKTOP">
                  <ImgBox
                    image={{
                      src: card.imgSrc,
                      alt: card.title,
                    }}
                    imgHeight="100%"
                    imgWidth="100%"
                  />
                </Box>
                <Box className="CLSImg showTABLET">
                  <ImgBox
                    image={{
                      src: card.SMImgSrc,
                      alt: card.title,
                    }}
                    imgHeight="100%"
                    imgWidth="100%"
                  />
                </Box>
                {card.videoSrc && (
                  <>
                    <Box
                      component="video"
                      className="CLSVideo showLargeDESKTOP"
                      autoPlay
                      muted
                      playsInline
                      loop>
                      <Box
                        component="source"
                        src={card.videoSrc.lg}
                        type="video/mp4"
                      />
                    </Box>
                    <Box
                      component="video"
                      className="CLSVideo showMobileAndTabletAndDesktop"
                      autoPlay
                      muted
                      playsInline
                      loop>
                      <Box
                        component="source"
                        src={card.videoSrc.sm}
                        type="video/webm"
                      />
                    </Box>
                  </>
                )}
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </StyledBox>
  );
};
export { CardsLayoutSection };
